import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const FloatingSyncButton = ({
  hasChangesToSync,
  synchronizePickingLoading,
  synchronizePicking,
  className,
}) => {
  const [showTooltip, setShowTooltip] = React.useState(false);

  const handleButtonClick = () => {
    // Only proceed if there are changes to sync
    if (!hasChangesToSync) {
      return;
    }

    // Provide haptic feedback on mobile devices
    if (navigator.vibrate) {
      navigator.vibrate(50);
    }
    synchronizePicking();
  };

  return (
    <div className={classNames("floating-sync-button", className)}>
      <button
        className={classNames("floating-sync-button__btn", {
          "floating-sync-button__btn--loading": synchronizePickingLoading,
          "floating-sync-button__btn--disabled":
            !hasChangesToSync && !synchronizePickingLoading,
        })}
        disabled={synchronizePickingLoading || !hasChangesToSync}
        onClick={handleButtonClick}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onFocus={() => setShowTooltip(true)}
        onBlur={() => setShowTooltip(false)}
        aria-label={
          hasChangesToSync
            ? "Synchroniser les modifications non sauvegardées"
            : "Aucune modification à synchroniser"
        }
        title={
          hasChangesToSync
            ? "Synchroniser les modifications"
            : "Aucune modification à synchroniser"
        }
      >
        <i
          className={classNames("fa", {
            "fa-sync-alt": !synchronizePickingLoading && hasChangesToSync,
            "fa-check": !synchronizePickingLoading && !hasChangesToSync,
            "fa-spinner fa-spin": synchronizePickingLoading,
          })}
          aria-hidden="true"
        />
        <span className="floating-sync-button__text">
          {synchronizePickingLoading
            ? "Sync..."
            : hasChangesToSync
            ? "Sync"
            : "OK"}
        </span>
      </button>

      {/* Sync status indicator - only show when there are changes to sync */}
      {hasChangesToSync && (
        <div className="floating-sync-button__indicator">
          <i className="fa fa-exclamation-circle" aria-hidden="true" />
        </div>
      )}

      {/* Tooltip for better UX */}
      {showTooltip && (
        <div className="floating-sync-button__tooltip">
          {synchronizePickingLoading
            ? "Synchronisation en cours..."
            : hasChangesToSync
            ? "Modifications non synchronisées"
            : "Aucune modification à synchroniser"}
        </div>
      )}
    </div>
  );
};

FloatingSyncButton.propTypes = {
  hasChangesToSync: PropTypes.bool.isRequired,
  synchronizePickingLoading: PropTypes.bool.isRequired,
  synchronizePicking: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default FloatingSyncButton;
